"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for Control Registration Parameters
 */
var ControlRegistrationParams = /** @class */ (function () {
    /**
     * Create a new ControlRegistrationParams instance
     *
     * @param definition  the service definition
     * @param group  the control group
     */
    function ControlRegistrationParams(definition, group) {
        this.definition = definition;
        this.group = group;
    }
    return ControlRegistrationParams;
}());
exports.ControlRegistrationParams = ControlRegistrationParams;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/control-registration-params.js
// module id = 824
// module chunks = 1